import { Shell } from "./layouts/Shell";
import { HomePage } from "./pages/HomePage";
import { ExplorePage } from "./pages/ExplorePage";
import { ProfilePage } from "./pages/ProfilePage";
import { PostPage } from "./pages/PostPage";
import { SavedPage } from "./pages/SavedPage";
import { NotificationsPage } from "./pages/NotificationsPage";
import { MessagesPage } from "./pages/MessagesPage";
import { AdminPage } from "./pages/AdminPage";
import { SearchPage } from "./pages/SearchPage";
import { AuthPage } from "./pages/AuthPage";
import { ComingSoonPage } from "./pages/ComingSoonPage";
import { useApi } from "./hooks/useApi";
import { api } from "./lib/api";

export function App() {
  const session = useApi(api.session, []);
  const path = decodeURIComponent(location.pathname);
  let page = <HomePage />;
  if (path === "/explore") page = <ExplorePage />;
  else if (path === "/flips" || path === "/reels") page = <ComingSoonPage title="Flips" label="Coming Soon" />;
  else if (path === "/search") page = <SearchPage />;
  else if (path.startsWith("/@")) page = <ProfilePage username={decodeURIComponent(path.slice(2))} />;
  else if (path.startsWith("/p/")) page = <PostPage id={decodeURIComponent(path.slice(3))} />;
  else if (path === "/saved") page = <SavedPage />;
  else if (path === "/notifications") page = <NotificationsPage />;
  else if (path === "/messages") page = <ComingSoonPage title="Messages" label="Coming Soon" />;
  else if (path === "/admin") page = <AdminPage />;
  else if (path === "/login") return <AuthPage mode="login" />;
  else if (path === "/signup") return <AuthPage mode="signup" />;
  return <Shell preview={session.data?.devIdentityMode} user={session.data?.user}>{page}</Shell>;
}
